import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import SelectACompanyPlaceholder from 'src/components/SelectACompanyPlaceholder';
import useViewDepartment from 'src/hooks/useViewDepartments';
import AssignGlCodes from './AssignGlCodes';
import AssignMembers from './AssignMembers';
import CopyFrom from './CopyFrom';
import DepartmentDropdown from './DepartmentDropdown';
import ManageDepartmentNavBar from './ManageDepartmentNavBar';
import ViewDepartmentNavbar from './ViewDepartmentNavbar';
import ViewDepartmentTable from './ViewDepartmentTable';

const ManageDepartments = () => {
  const { selectedDepartment, pageTitle } = useViewDepartment();
  return (
    <>
      <Navbar title={pageTitle} />
      {Object.keys(selectedDepartment).length ? (
        <Layout>
          <ManageDepartmentNavBar />
          <div className="flex flex-row gap-6">
            <DepartmentDropdown />
            <CopyFrom />
          </div>
          <div className="flex flex-row mt-4 gap-6">
            <AssignGlCodes />
            <AssignMembers />
          </div>
        </Layout>
      ) : (
        <Layout>
          <ViewDepartmentNavbar />
          <SelectACompanyPlaceholder display={<ViewDepartmentTable />} />
        </Layout>
      )}
    </>
  );
};

export default ManageDepartments;
